// Added by Sejune Oh on 2020-04-09
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, forwardRef } from 'react'
import {
  DialogContent as MaterialUIDialogContent,
  DialogContentProps as MaterialUIDialogContentProps,
} from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface DialogContentBaseProps {}
export type DialogContentProps = MaterialUIDialogContentProps & DialogContentBaseProps

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const DialogContent:FC<DialogContentProps> = forwardRef(({...props}, ref) => {
    return <MaterialUIDialogContent ref={ref} {...props} />
})
